var $ = jQuery;

// JS libraries included in plugins.min.js
$(window).setBreakPoints([360,540,768,1024,1280]);

// Detects Touch Event
window.addEventListener('touchstart',function onFirstTouch(){
	document.documentElement.className += " touch";
	window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

// Global Variables - Page/Viewport Heights
var pageHeight;
var viewHeight;
var menuHeight;

// Global Variables - Vimeo Player for Modal
var vimeoModalPlayer;

// Global - Google Tag Manager
window.dataLayer = window.dataLayer || [];

/* jQuery Constructor: Page Listener */
jQuery(document).ready(function($) {

	// Sets Element Height Values
	pageHeight = $('body').outerHeight();
	viewHeight = vhCheck().vh;
	menuHeight = $('header .container').outerHeight();

	initMobileNav();
	closeMobileNav();
	initSlider();
	initVideoModal();
	initUpperBanner();

});

// =====================================================================
// Upper Banner
// =====================================================================
function initUpperBanner(){
	var cookie = Cookies.get('Banner_Shown');
	var showBanner = true;
	if (cookie !== undefined && cookie == 'true'){
		showBanner = false;
	}
	if (showBanner){
		$('#upperBanner').slideDown(300,'linear',function(){
			setTimeout(function(){
				window.scrollTo({top:0, behavior:'smooth'});
			}, 300);
		});
		$('#upperBanner a.button').click(function(){
			var buttonText = $(this).text().toLowerCase();
			pushGAEvent('Banner','TopBanner','button: '+buttonText);
		});
		$('#upperBanner svg.close').click(function(){
			$('#upperBanner').slideUp(300,'linear',function(){
				Cookies.set('Banner_Shown','true');
				pushGAEvent('Banner','TopBanner','clickClose');
			});
		});
	}
}

// ===================================================================
// Global Function to control mobile navigation
// ===================================================================
function initMobileNav() {
	$('#toggle-bars').click(function() {
		$('.mobile-menu').slideDown();
	});
}
function closeMobileNav() {
	$('#close-btn').click(function() {
		$('.mobile-menu').slideUp();
	});
}

// ===================================================================
// Global Function to setup image carousel
// ===================================================================
function initSlider(){

	$('.slideshow').slick({
		autoplay: true,
		autoplaySpeed: 2000,
		arrows: false,
		dots: true,
		pauseOnHover: true,
		pauseOnFocus: false
	});

}

// =====================================================================
// Video - Modals Player
// =====================================================================
function initVideoModal(){

	$('.modalTrigger').click(function(event){
		event.preventDefault();
		var vimeoID = $(this).data('vimeo');
		var modalWidth = $(this).data('width');
		var modalHeight = $(this).data('height');

		//Checks for Custom Video Sizes
		if (modalWidth !== undefined && modalHeight !== undefined){
			viewHeight = vhCheck().vh;
			var viewWidth = window.innerWidth-20;

			// Makes sure width will fit viewport
			if (modalWidth > viewWidth){
				modalHeight = (viewWidth * modalHeight) / modalWidth;
				modalWidth = viewWidth;
			}
			// Set Modal Size Properties
			document.documentElement.style.setProperty('--modal-width',modalWidth+'px');
			document.documentElement.style.setProperty('--modal-height',modalHeight+'px');
			$('#modal').addClass('customSize');
		}

		vimeoModalPlayer = new Vimeo.Player($('#modal #video-player'),{id:vimeoID});
		vimeoModalPlayer.loadVideo(vimeoID).then(function(){
			openModal();
			vimeoModalPlayer.play().catch(function(error){
				console.error(error);
			});
			pushGAEvent('Video','VimeoID',vimeoID);
			//Requires Vimeo Tracking to be loaded via GTM
			try {
				window.__vimeoRefresh();
			} catch(error) {
				//console.error('Vimeo Tracking Did Not Load');
			}
		});
	});

}

// =====================================================================
// Global Functions: Modal Open/Close, Window Lock/Unlock, Window Scroll
// =====================================================================
function openModal(modalView,modalInner,modalIndex){

	// Locks the background window and opens modal
	lockWindow(function(){
		vhCheck();
		$('#modal').addClass(modalView);
		if (modalInner !== ''){
			$('#modal .innerBio').html(modalInner);
		}
		if (modalIndex !== ''){
			$('#modal .innerBio').attr('data-index',modalIndex);
		}
		if (modalView == 'view-bio'){
			$('#modal .modal-buttons .arrow-left').unbind('click').click(function(){
				modalNav('arrow-left');
			});
			$('#modal .modal-buttons .arrow-right').unbind('click').click(function(){
				modalNav('arrow-right');
			});
		}
		$('html').addClass('showModal');
	});

	// Close Modal Button Listener
	$('#modal .modal-box .close').unbind('click').click(function(event){
		event.preventDefault();
		closeModal();
	});
}
function closeModal(){
	// Unlocks the background window and closes modal
	unlockWindow(function(){
		$('html').removeClass('showModal');

		// Stops video if enabled
		if (typeof vimeoModalPlayer != 'undefined'){
			vimeoModalPlayer.pause();
			vimeoModalPlayer.setCurrentTime(0);
		}

		// wait for the modal to fade out
		setTimeout(function(){

		}, 250);

	});
}
function lockWindow(callback){
	// Locks the background window
	var scrollPos = $(window).scrollTop();
	$('body').data('scrollPos',scrollPos);
	scrollPos = scrollPos * -1;
	$('html').addClass('noScroll').css('top',scrollPos+'px');
	if(callback !== undefined){
		callback();
	}
}
function unlockWindow(callback){
	// Unlocks the background window
	$('html').removeClass('noScroll').css('top','');
	$(window).scrollTop($('body').data('scrollPos'));
	if(callback !== undefined){
		callback();
	}
}

// ===================================================================
// Global Function to tell what page is viewed based on body class/ID
// ===================================================================
function isPage(a){
	if($('body#'+a).length){return true;}
	else if ($('body').hasClass(a)){return true;}
	else if ($('body').hasClass('page-'+a)){return true;}
	else{return false;}
}

// ===================================================================
// Global Function: Triggers GTM Google Analytics
// ===================================================================
function pushGAEvent(category,action,label){
	//Uses same method as GMT for defining Category
	if (window.location.href.includes('enhanced-recovery')){
		category = "Enhanced Recovery";
	} else if (window.location.href.includes('cystic-fibrosis')){
		category = "Cystic Fibrosis";
	} else if (window.location.href.includes('chase-gardens')){
		category = "Chase Gardens";
	}

	window.dataLayer.push({
		'event': 'GoogleAnalyticsEvent',
		'GAEvent_category': category,
		'GAEvent_action': action,
		'GAEvent_label': label
	});
	//console.log('gaEvent: '+category+'|'+action+'|'+label);
}